import { render, staticRenderFns } from "./CustomerAuthorizations.vue?vue&type=template&id=44e73123&"
import script from "./CustomerAuthorizations.vue?vue&type=script&lang=js&"
export * from "./CustomerAuthorizations.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAuthorizations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports